import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';
import { AiSourcingPollingService } from 'src/app/_services/ai-sourcing-polling.service';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { InsightsDataService } from 'src/app/_services/insights-data.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { SimilarCandidateService } from 'src/app/_services/similar-candidate.service';
import { StatsMatrixHandlerService } from 'src/app/_services/stats-matrix-handler.service';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { JdDataService } from 'src/app/jd-data.service';
import * as _ from 'underscore';

declare const clevertap;

@Component({
    selector: 'app-ai-sourcing-insights',
    templateUrl: './ai-sourcing-insights.component.html',
    styleUrls: ['./ai-sourcing-insights.component.scss'],
    standalone: false
})
export class AiSourcingInsightsComponent implements OnInit {
  malePercent: any = null;
  femalePercent: any = null;
  totalCandidatesCount: any = null;
  changedJobs: any = null;
  totalCandidatesCountAvailable: boolean = true;
  medianTenureInCountAvailable: boolean = true;
  totalMedianTanureCount: any = null;
  genderDataAvailable: boolean = true;
  changedJobsCountAvailable: boolean = true;
  projectnumber: string = '';
  similarObject: any;
  projectDetails: any;
  insightsData: any;
  insightsSubject: Subject<any> = new Subject();
  @ViewChild('holdingTemplate') holdingTemplate: TemplateRef<any>;

  pollingSub: Subscription;
  /**
   * To show ai sourcing progress for a project
   */
  progress: number = 0;
  aiSourcingStatus: string;

  // radius of the circle
  circleRadius = 12;

  // circumference = 2 * PI * r
  circumference = 2 * Math.PI * this.circleRadius;
isAISourcingEnabled: boolean = false;
  subs: Subscription[] = [];

  hasJobDemand: boolean = false;
  combinedAggregates: any = {};
  combinedLocation: any[] = [];
  combinedJobtitle: any[] = [];
  combinedSkills: any[] = [];
  combinedIndustry: any[] = [];
  jobDemandCount: string = '';
  medianSalary: string = '';
  currencyData: any[] = [];
  selectedCurrency: any = null;
  target_currency_rate: number = 1;
  target_fav_icon: string = 'fa-dollar-sign';
  currency: string = 'USD';
  currency_symbol: string = '$';

  constructor(private aggregationService: AggregationService, private localstorageService: LocalStorageService,
    private statsMatrixHandlerService: StatsMatrixHandlerService, private aiSourcingService: AiSourcingService,
    private personSearchService: PersonSearchService, private similarCandidateService: SimilarCandidateService,
    private jdDataService: JdDataService, private route: ActivatedRoute, private router: Router, private pollingService: AiSourcingPollingService,
    private aiSourcingHandlerService: AiSourcingHandlerService, private insightsDataService: InsightsDataService, private modalService: NgbModal, private talentInsightsService: TalentInsightsService, private filterDataHandlerService: FilterDataHandlerService, private aggService: AggregationService) {

  }

  ngOnInit() {

    const similarobj = this.jdDataService.jdDataFromSession;
   this.personSearchService.passsimilarcandidatesdata({ data: similarobj, calledfrom: GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION });
   this.similarObject = this.personSearchService.getsimilarcandidatesdata();

    this.projectnumber = window.location.pathname?.split('/')[3];
    this.isAISourcingEnabled = this.localstorageService.getItem('autopilotslotaccess') == '1' ? true : false;

    this.getProjectDetails();
    this.showLoader();
  }

  setMatrixStats(res: any) {
    this.totalCandidatesCountAvailable = true;
    this.genderDataAvailable = true;
    let response = res.find(el => !!el?.data?.aggregations?.gender);
       const maleCount = response?.data && response?.data?.aggregations && response?.data?.aggregations?.gender && response?.data?.aggregations?.gender.filter(g => g.key == 'male')[0] && response.data.aggregations.gender.filter(g => g.key == 'male')[0].doc_count || 0;
       const femaleCount = response?.data && response?.data?.aggregations && response?.data?.aggregations?.gender && response?.data?.aggregations?.gender.filter(g => g.key == 'female')[0] && response.data.aggregations.gender.filter(g => g.key == 'female')[0].doc_count || 0;
       this.malePercent = maleCount ? ((maleCount / (maleCount + femaleCount)) * 100).toFixed(0) : 0;
       this.femalePercent = femaleCount ? ((femaleCount / (maleCount + femaleCount)) * 100).toFixed(0) : 0;
      this.statsMatrixHandlerService.setMatrixStaticData({ malePercent: this.malePercent, femalePercent: this.femalePercent });

       this.totalCandidatesCount = response?.data && response?.data?.totalresultscount && response?.data?.totalresultscount;
       response = res.find(el => !!el.data.aggregations.changedjobs);
       this.changedJobs = response?.data && response?.data?.aggregations && response?.data?.aggregations?.changedjobs && response?.data?.aggregations?.changedjobs?.doc_count;
       this.statsMatrixHandlerService.setMatrixStaticData({ changedJobs: this.changedJobs });
       this.changedJobsCountAvailable = true;

       response = res.find(el => !!el.data.aggregations.total_tenure_median);
       this.totalMedianTanureCount = response?.data && response?.data?.aggregations && response?.data?.aggregations?.total_tenure_median && response?.data?.aggregations?.total_tenure_median?.value;
       this.statsMatrixHandlerService.setMatrixStaticData({ totalMedianTanureCount: this.totalMedianTanureCount });
       this.medianTenureInCountAvailable = true;

      //  this.ngZone.run(() => {
      //    this.setCountAvailableAll();
      //  })
  }

  setChangeJobStats(res: any) {
    // Logic to handle changed job stats
  }

  showLoader() {
    this.totalCandidatesCountAvailable = false;
    this.medianTenureInCountAvailable = false;
    this.genderDataAvailable = false;
    this.changedJobsCountAvailable = false;
  }

    formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }

    getFormattedTenureForMatrix(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (tenure == null) {
      return 0;
    } else if (totalYears > 0 && totalMonths > 0) {
      if (totalMonths == 12) {
        return `${totalYears + 1} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
      } else {
        return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()} ${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
      }
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      if (totalMonths == 12) {
        return `${totalYears + 1} ${this.returnSpanTag('Yr').outerHTML.toString()}`;
      } else
        return `${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
    } else {
      return '';
    }
  }

    returnSpanTag(text) {
    let spanTag = document.createElement("span");
    spanTag.className = 'median-tenure-text-size';
    spanTag.innerHTML = text
    return spanTag;
  }

  get strokeDashOffset() {
    // progress 0-100, convert to stroke offset
    return this.circumference * (1 - this.progress / 100);
  }
  getProjectDetails() {
    this.aiSourcingService.getProjectDetails(this.projectnumber).subscribe((res: any) => {
      if(res.data.aisourcingstatus != 'completed')
          this.modalService.open(this.holdingTemplate, { size: "lg", centered: true })

      this.projectDetails = res.data;
      this.aiSourcingStatus = res.data.aisourcingstatus;
      if(res.data.aisourcingstatus === 'started' || res.data.aisourcingstatus === 'pending'){
        this.pollingSub = this.pollingService.startPolling(this.projectnumber).subscribe(res => {
          this.progress = res.data?.progress !== null ? res.data?.progress : this.progress;
          if(res.data?.progress ===100){
            this.getProjectDetails()
          }
        });
      }
      this.aiSourcingHandlerService.setProjectDetails(this.projectDetails);
      this.aiSourcingService.emitProjectDetailsEvent(this.projectDetails);
      // this.similarObject.data = this.updatedSimilarObjectData;

      // this.similarCandidateService.setSimilarCandidatesData(this.similarObject.data);
      //    this.personSearchService.passsimilarcandidatesdata({ data: this.similarObject.data, calledfrom: GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION });
      //    const uniqueHash = this.route.snapshot.queryParamMap.get(GeneralConstants.LS_KEYS.UNIQUE_HASH);
      //    this.jdDataService.setSessionData(uniqueHash, this.similarObject.data);
      //    this.similarCandidateService.setSimilarCandidatesDatafholdingTemplatez(this.similarObject.data);
      //    this.jdDataService.jdFilterUpdateEventEmit();
    this.aggregationService.getStatsAggsAISourcing(this.projectnumber);

    const statsUpdateSub = this.aiSourcingHandlerService.statsAIUpdateEvent.subscribe(res => this.setMatrixStats(res));
    this.subs.push(statsUpdateSub);
    this.getCombinedAggregates();

    })
  }

  private get updatedSimilarObjectData() {
    const scObject = Object.assign({}, this.similarObject.data);
    scObject.jobtitle = this.projectDetails.jobtitles.map(jt => ({ key: jt, isMandatory: false, isSuggested: false, suggestedKey: false }));
    scObject.skills = this.projectDetails.skills.map(skill => ({ key: skill, isMandatory: skill.starred, isSuggested: skill.isSuggested, suggestedKey: skill.key }));
    scObject.currentlocation = [{ key: this.projectDetails.location, isMandatory: false, isSuggested: false, suggestedKey: null }];
    scObject.jobindustryname = this.projectDetails.industries.map(ci => ({ key: ci, isMandatory: ci.starred, isSuggested: ci.isSuggested, suggestedKey: ci.key }));
    scObject.jobcompanyname = this.projectDetails.companies.map(cn => ({ key: cn, isMandatory: cn.starred, isSuggested: cn.isSuggested, suggestedKey: cn.key }));
    scObject.fromyearsofexperience = this.projectDetails.minExperience ? this.projectDetails.minExperience : null;
    scObject.toyearsofexperience = this.projectDetails.maxExperience ? this.projectDetails.maxExperience : null;
    scObject.seniority = this.projectDetails.seniority ? this.projectDetails.seniority : null;
    scObject.function = this.projectDetails.function ? this.projectDetails.function : null;
    scObject.locationcontinent = this.projectDetails.continent;
    scObject.schools = [];
    scObject.degrees = [];
    scObject.fieldOfStudy = [];
    scObject.companysize = [];
    return scObject;
  }

  redirectToReview() {
    if(this.projectDetails?.aisourcingstatus !== 'completed' && (!this.projectDetails?.talenttotalstrength || this.projectDetails?.talenttotalstrength == 0 )) return;
    if(this.projectDetails?.status == 'inactive') {
      this.aiSourcingHandlerService.setDisplayPageEvent('shortlist');
      this.router.navigate([`/ai-sourcing/ai-sourcing-profiles/shortlist/${this.projectnumber}`]);
      return;
    }
      this.aiSourcingHandlerService.setDisplayPageEvent('review');
       /**
     * Click on Review Candidates
     */
         const evaluationParams = {
          "User ID": this.localstorageService.getItem('userdata').userid,
          "Project Number": this.projectnumber

        }
        clevertap.event.push("Autopilot-To Review candidate listing",evaluationParams);
     this.router.navigate(['/ai-sourcing/ai-sourcing-profiles/review/'+this.projectnumber])
  }

  /**
   * Method to use redirect to the project details page
   */
  goToDetailsPage(type) {
    // this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
    // this.router.navigate([`/ai-sourcing/project-details/${this.projectnumber}`]);
    if(type == 'project-details'){
    this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
    this.router.navigate([`/ai-sourcing/project-details/${this.projectnumber}`]);
    }else if(type == 'autopilot-criteria'){
      this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
      this.router.navigate([`/ai-sourcing/project-details/${this.projectnumber}/autopilot-evaluation-criteria`]);
    }else if(type == 'autopilot-activity'){
      this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
      this.router.navigate([`/ai-sourcing/project-details/${this.projectnumber}/autopilot-activity`]);
    }
  };

  insightsEventHandler(event: any) {
        const action = event.action;
    switch (action) {
      case 'aidata': {
        this.insightsData = event.data;
        this.insightsData['totalResultsCount'] = this.totalCandidatesCount || 0;
        this.insightsData['totalmedianTenure'] = this.totalMedianTanureCount || 0;
        this.insightsData['changedJobs'] = this.changedJobs || 0;
        this.insightsData['projectname'] = this.projectDetails.projectname;
        this.insightsData['activejobcount'] = this.jobDemandCount ? this.jobDemandCount : '—';
        this.insightsData['salary'] = this.medianSalary ? this.medianSalary : '—';
        this.insightsSubject.next(this.insightsData);
        this.aiSourcingService.emitInsightsAiEvent(event.data);
        break;
      }
        break;
      }
    }

    dismiss() {
      this.modalService.dismissAll();
    }

    ngOnDestroy() {
      if (this.pollingSub) this.pollingSub.unsubscribe();
      this.subs.forEach(sub => sub.unsubscribe());
      this.projectnumber = '';

    }
  /**
  *
  * @param string
  * @returns
  */
  chipCleanUp(value: any) {
    const normalize = (item: any): string => {
      if (item === null || item === undefined) return '';

      let text = '';
      if (typeof item === 'string') {
        text = item;
      } else if (typeof item === 'object') {
        text = item.chipkey || item.key || item.value || '';
      } else {
        text = String(item);
      }

      return text.includes('.aisearch') ? text.split('.aisearch')[0] : text;
    };

    if (Array.isArray(value)) {
      return value.map((item: any) => normalize(item)).filter(Boolean).join(', ');
    }

    if (typeof value === 'string') {
      return value.split(',').map((res: string) => normalize(res.trim())).filter(Boolean).join(', ');
    }

    return normalize(value);
  };

    getCombinedAggregates() {
    this.hasJobDemand = true;
    const aggReq = {
      'aggregatetype' : "jobs_base_aggregates",
      'aggregatescount': 5
    }
    this.aiSourcingService.getTotalAISourcingAggs(this.projectnumber, aggReq).subscribe(response => {
      const tempData = response?.data?.aggregations;
      this.combinedAggregates = tempData;
      this.combinedIndustry = this.combinedAggregates['current_industry'];
      this.combinedSkills = this.combinedAggregates['skills'];
      this.combinedJobtitle = this.combinedAggregates['current_jobtitle'];
      this.combinedLocation = this.combinedAggregates['location'];
      if(this.combinedIndustry.length > 0 || this.combinedSkills.length > 0 || this.combinedJobtitle.length > 0 || this.combinedLocation.length > 0) {
        this.getCurrency()
      }else{
        this.jobDemandCount = ''
        this.medianSalary = ''
        this.hasJobDemand = false
      }
    });
  }

    getJobsAggregates() {
      const payload = {
        aggregatetype: 'median_salary',
        startindex: 0,
        resultsize: 10,
        locations: _.pluck(this.combinedLocation, 'key'),
        skills: _.pluck(this.combinedSkills, 'key'),
        jobtitles: _.pluck(this.combinedJobtitle, 'key'),
        industries: _.pluck(this.combinedIndustry, 'key'),

      }
      this.talentInsightsService.getJobsAggregates(payload).subscribe((response: any) => {
        const tempData = response?.data?.aggregations['median_salary'];
        this.hasJobDemand = false;
        this.jobDemandCount = this.formatNumberToIndianFormat(tempData?.job_demand?.doc_count) || '';
        if (this.target_fav_icon == 'fa-money-bill') {
          this.medianSalary = tempData?.median_salary_max ? `${this.currency} ${this.formatNumber((tempData?.median_salary_min?.value) * this.target_currency_rate)} - ${this.currency} ${this.formatNumber((tempData?.median_salary_max.value) * this.target_currency_rate)}` : '0';
        } else this.medianSalary = tempData?.median_salary_max ? `<i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber((tempData?.median_salary_min?.value * this.target_currency_rate))} - <i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber(tempData?.median_salary_max.value * this.target_currency_rate)}` : '0';
          this.insightsData && (this.insightsData['activejobcount'] = this.jobDemandCount)  ;
           if(tempData.median_salary_max.value == null && tempData.median_salary_min.value == null ){
            this.medianSalary = ''
           }
        this.insightsData && (this.insightsData['salary'] = this.medianSalary);
        this.insightsSubject.next(this.insightsData);

      })
    }


  formatNumber(number: number): string | number {
    if (!number) return 0;

    const suffixes = ['', 'K', 'M', 'B', 'T'];
    let index = 0;

    while (Math.abs(number) >= 1000 && index < suffixes.length - 1) {
      number /= 1000;
      index++;
    }

    return Math.round(number) + suffixes[index];
  }

  getCurrency() {
    this.talentInsightsService.getCountryCurrency().subscribe((response: any) => {
      this.currencyData = response?.data;
      if(this.projectDetails.location) {
         const locations = this.projectDetails.location;
        const payload = { locations: locations }
        this.talentInsightsService.getLocationCurrency(payload).subscribe((res: any) => {
          if (res.status === 'success' && res.data) {
           this.localstorageService.setItem('insightsjobCurrency', res.data.base_currency);
            this.localstorageService.setItem('currencyCountry', res.data.country_name);
               if (res.data.base_currency) {
        const selectedCurrency = this.currencyData.find((x: any) => x.target_currency === res.data.base_currency);
        if (selectedCurrency) {
          this.target_currency_rate = selectedCurrency.rate;
          this.currency = selectedCurrency.target_currency;
          this.target_fav_icon = selectedCurrency.target_currency_fav_icon;
          this.currency_symbol = selectedCurrency.target_currency_symbol;
        }
      }
          }
        })
      } else {
   const currency = this.localstorageService.getItem('insightsjobCurrency');
      if (currency) {
        const selectedCurrency = this.currencyData.find((x: any) => x.target_currency === currency);
        if (selectedCurrency) {
          this.target_currency_rate = selectedCurrency.rate;
          this.currency = selectedCurrency.target_currency;
          this.target_fav_icon = selectedCurrency.target_currency_fav_icon;
          this.currency_symbol = selectedCurrency.target_currency_symbol;
        }
      }
      }

      this.getJobsAggregates();

    })
  }

  getCurrencyData(source?: string) {

    const filterData = this.filterDataHandlerService.fetchFilterData;
    const aggReq = this.aggService.getRequestWithFilters();
    if (filterData && filterData.locationSelectedList.length > 0) {
      if (source === 'filterChange') {
        const locations = filterData.locationSelectedList.map(loc => loc.key.replace('.searchastext', ''));
        const payload = { locations: locations }
        this.talentInsightsService.getLocationCurrency(payload).subscribe((res: any) => {
          if (res.status === 'success' && res.data) {
            this.localstorageService.setItem('jobCurrency', res.data.base_currency);
            this.localstorageService.setItem('currencyCountry', res.data.country_name);
            // this.setUpdatedData(null, true);
          }
        })
      } else {
        this.currency = this.localstorageService.getItem('jobCurrency') || 'USD';
        // this.setUpdatedData(null, true);

      }
    } else if (this.jdDataService.isComingFromJobDescription) {
      if (source === 'jdUpdate') {
        if (aggReq && aggReq?.job_description_keys && aggReq?.job_description_keys?.locations?.length > 0) {
          const locations = aggReq.job_description_keys?.locations;
          const payload = { locations: locations }
          this.talentInsightsService.getLocationCurrency(payload).subscribe((res: any) => {
            if (res.status === 'success' && res.data) {
              this.localstorageService.setItem('jobCurrency', res.data.base_currency);
              this.localstorageService.setItem('currencyCountry', res.data.country_name);
              // this.setUpdatedData(null, true);
            }
          })
        }
      } else {

          this.currency = this.localstorageService.getItem('jobCurrency') || 'USD';
          // this.setUpdatedData(null, true);
      }
    //     } else{
    //  if (aggReq && aggReq?.job_description_keys && aggReq?.job_description_keys?.locations?.length > 0) {
    //       const locations = aggReq.job_description_keys?.locations;
    //       const payload = { locations: locations }
    //       this.talentInsightsService.getLocationCurrency(payload).subscribe((res: any) => {
    //         if (res.status === 'success' && res.data) {
    //           this.localstorageservice.setItem('jobCurrency', res.data.base_currency);
    //           this.localstorageservice.setItem('currencyCountry', res.data.country_name);
    //           this.setUpdatedData(null, true);
    //         }
    //       })
        } else {
          this.currency = this.localstorageService.getItem('jobCurrency');
          // this.setUpdatedData(null, true);
        }
        }
}
